const translatables = [
	{
		path: '/network/translatables/list',
		name: 'network-translatables-list',
		component: () => import('@/views/network/translatables/list.vue'),
		meta: {
			roles: ['MGN,admin'],
			layout: 'content',
			module: 'MGN,projects-keys',
		},
	},
]

export default translatables
